import { useMutation } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { defaultConfig } from 'config/default'
import { downloadAs } from 'utils/downloadFile'

type UseExportUsersMutationProps = {
	chosenExportFormat: any
	checkedUsers: number[]
	clearSelection: () => void
	closeFormatModal: () => void
	setChosenExportFormat: (format: number | string | null) => void
}

export const useExportUsersMutation = ({
	chosenExportFormat,
	checkedUsers,
	clearSelection,
	closeFormatModal,
	setChosenExportFormat
}: UseExportUsersMutationProps) => {
	const axiosPrivate = useAxiosPrivate()
	const { t } = useTranslation()

	const { mutate: exportMutation, isPending: isExportLoading } = useMutation({
		mutationFn: () => {
			return axiosPrivate.post('/accounts/export/', {
				format: chosenExportFormat,
				ids: checkedUsers
			})
		},
		onSuccess: (res) => {
			const format = defaultConfig.exportFormatOptions
				.find((format) => format.value === chosenExportFormat)
				?.label.toLowerCase()

			if (format) {
				downloadAs({ file: res.data, name: 'users-export', format })
			}

			clearSelection()
			useToast({
				type: 'success',
				message: t('Users exported')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			closeFormatModal()
			setChosenExportFormat(null)
		}
	})

	return {
		exportMutation,
		isExportLoading
	}
}
